<div ngbDropdown placement="bottom-right">

    <button class="btn btn-sm btn-icon-only text-warning" (click)="navigateTo(endpoint+'/edit/'+row[index])"
        *ngIf="show_edit_button" title="Modifier">
        <i class="fas fa-edit"></i>
    </button>
    <button class="btn btn-sm btn-icon-only text-danger" *ngIf="show_delete_button" (click)="delete()"
        title="Supprimer">
        <i class="fa fa-trash"></i>
    </button>
    <button class="btn btn-sm btn-icon-only {{ action.class }}" *ngFor="let action of visible_actions"
        (click)="action.onClick(row)" title="{{ action.title }}">
        <i class="{{ action.icon }}"></i>
    </button>
    <button
        class="btn btn-sm btn-icon-only {{ ((action.relation == '') ? !row[action.index] : !row[action.relation][action.index]) ? action.class[0] : action.class[1] }}"
        *ngFor="let action of multi_actions"
        title="{{ ((action.relation == '') ? !row[action.index] : !row[action.relation][action.index]) ? action.title[0] : action.title[1] }}"
        (click)="((action.relation == '') ? !row[action.index] : !row[action.relation][action.index]) ? action.onClickToInactive(row) : action.onClickToActive(row)">
        <i
            class="{{ ((action.relation == '') ? !row[action.index] : !row[action.relation][action.index]) ? action.icon[0] : action.icon[1] }}"></i>
    </button>


    <button class="btn btn-sm btn-icon-only {{ action.class }}" *ngFor="let action of custom_generated_buttons" title="{{ action.title }}"
        (click)="action.onClick()">
        <i class="{{ action.icon }}"></i>
    </button>

    <div *ngFor="let action of actions_with_condition" style="float: left;">
        <button
            *ngIf="row[action.condition_index[0]['index']] == action.condition_index[0]['value'] && row[action.condition_index[0]['index']] != null"
            class="btn btn-sm btn-icon-only {{ action.class }}" title="{{ action.title }}"
            (click)="action.onClick(row)">
            <i class="{{ action.icon }}"></i>
        </button>
    </div>

    <button class="btn btn-sm btn-icon-only text-light" ngbDropdownToggle *ngIf="invisible_actions.length > 0">
        <i class="fas fa-ellipsis-v"></i>
    </button>

    <div ngbDropdownMenu class=" dropdown-menu-right dropdown-menu-arrow">
        <button class="dropdown-item" href="javascript:void(0)" *ngFor="let action of invisible_actions"
            (click)="action.onClick(row)">{{ action.title }}</button>
    </div>

</div>